import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <footer id="contact" className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <h3 className="text-3xl font-bold mb-4">
              <span className="iridescent-text-white">BIO-PEPTIDE</span>
            </h3>
            <p className="text-2xl font-light text-blue-200 mb-4">PEN</p>
            <p className="text-blue-100 leading-relaxed">
              Leading the future of bio-peptide innovation with premium-quality solutions for enhanced health and performance.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-xl font-bold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-blue-300 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-blue-100 text-sm mb-1">Email</p>
                  <a
                    href="mailto:biopeptidepen@info.com"
                    className="text-white hover:text-blue-200 transition-colors duration-300 font-medium"
                  >
                    biopeptidepen@info.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-xl font-bold mb-6">Our Location</h4>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-blue-300 flex-shrink-0 mt-1" />
              <div>
                <p className="text-blue-100 leading-relaxed">
                  Bio-Peptide Ltd<br />
                  21/F, Vita Tower<br />
                  30 Wong Chuk Hang Road<br />
                  Aberdeen, Hong Kong
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="border-t border-blue-700 pt-8 mb-8">
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a href="#about" className="text-blue-200 hover:text-white transition-colors duration-300">
              About Us
            </a>
            <a href="#products" className="text-blue-200 hover:text-white transition-colors duration-300">
              Products
            </a>
            <a href="#why-choose-us" className="text-blue-200 hover:text-white transition-colors duration-300">
              Why Choose Us
            </a>
            <a href="#validation" className="text-blue-200 hover:text-white transition-colors duration-300">
              Validation
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-blue-700 pt-8 text-center">
          <p className="text-blue-200 text-sm">
            © {new Date().getFullYear()} Bio-Peptide Ltd. All rights reserved.
          </p>
          <p className="text-blue-300 text-xs mt-2">
            Premium Bio-Peptide Solutions | Made with precision in Hong Kong
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
